import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=80ce1e48"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./NotificationCard.vue?vue&type=style&index=0&id=80ce1e48&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports